import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { te } from 'date-fns/locale';

@Injectable({
    providedIn: 'root'
})
export class WhatsappIntegrationApi {

    constructor(private http: HttpClient) { }

    private token: string = 'EAAMlz0ZB0EJQBPVGTkO4YqTjzAitXmWyw6D17dbZBGpo4BYdANPKOoMiOPscgFgJ5O73eNhICS7an16FxdDIcvhMQC5Kfp4rwM84gfmNPZACUtkU2E37ZA434TkGdyPYxBfrUCUZApmiZA5rPOmCkdbu9l0fZBkvQTpsJtN3DQpPOW1P3GQQ7zd8EcMl4HLTdrtgVssz0Khwx57ggwmGouDa5tmukxoIXgdrSjDqYg1Ps4ZD';
    private apiUrl = 'https://graph.facebook.com/v22.0/112955978413244/messages?access_token=';

    sendBulkMessage(listOfCustomers: any, token: string): Observable<any> {
        const apiUrlWithToken = this.apiUrl + token;
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        };

        listOfCustomers.forEach((customer) => {

            const body = {
                messaging_product: 'whatsapp',
                to: customer.customerPhone,
                type: 'template',
                template: '{ "name": "hello_world", "language": { "code": "en_US" } } '
            };

            this.http.post(apiUrlWithToken, body, httpOptions).subscribe(
                (response) => console.log(response),
                (error) => console.log(error)
            )

        });
        return new Observable();

    }

    sendMessage(customer: any, token: string, url?: string) {
        token = token ? token : this.token;
        // const apiUrlWithToken = this.apiUrl + token;
        const apiUrlWithToken = url + `?access_token=${token}`;

        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            })
        };

        const templateObj = {
            name: customer?.templateName,
            language: { code: customer?.languageCode ?? 'en_US' },
            components: [
                {
                    type: 'body',
                    parameters: customer?.parameters?.map(param => ({
                        type: "TEXT",
                        text: param?.text
                    }))
                }
            ]
        };

        const body = {
            messaging_product: 'whatsapp',
            to: customer?.phone,
            type: 'template',
            template: JSON.stringify(templateObj)
        };

        return this.http.post(apiUrlWithToken, body, httpOptions);

    }
    sendMetaMessage(customer: any, token: string, url?: string) {
        token = token ? token : this.token;
        // const apiUrlWithToken = this.apiUrl + token;
        const apiUrlWithToken = url + `?access_token=${token}`;

        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            })
        };

        const templateObj = {
            name: customer?.templateName,
            language: { code: customer?.languageCode ?? 'en_US' },
            components: [
                {
                    type: 'body',
                    parameters: customer?.parameters?.map(param => ({
                        type: "TEXT",
                        text: param?.text
                    }))
                }
            ]
        };

        // const body = {
        //     messaging_product: 'whatsapp',
        //     to: customer?.phone,
        //     type: 'template',
        //     template: JSON.stringify(templateObj)
        // };
        const body = {
            "messaging_product": "whatsapp",
            "to": customer?.phone,
            "type": "template",
            "template": {
                "name": customer?.templateName,
                "language": { code: customer?.languageCode ?? 'en_US' },
                "components": 
                customer?.showTextOrImage === "IMAGE"?
                [
                    {
                        "type": "header",
                        "parameters": [
                            {
                                "type": "IMAGE",
                                "image": {
                                    "link": customer?.imgLink
                                }
                            }
                        ]
                    },
                    {
                        "type": "body",
                        "parameters": customer?.parameters?.map(param => ({
                        type: "TEXT",
                        text: param?.text
                    }))
                    }
                ] 
                :
                customer?.showTextOrImage === "DOCUMENT"?
                [
                    {
                        "type": "header",
                        "parameters": [
                        {
                            "type": "document",
                            "document": {
                            "link": customer?.imgLink,
                            "filename": customer?.fileName
                            }
                        }
                        ]
                    },
                    {
                        "type": "body",
                        "parameters": customer?.parameters?.map(param => ({
                        type: "TEXT",
                        text: param?.text
                    }))
                    }

                ]:
                [
                    {
                        "type": "body",
                        "parameters": customer?.parameters?.map(param => ({
                        type: "TEXT",
                        text: param?.text
                    }))
                    }
                ]                 

            }
        }

        return this.http.post(apiUrlWithToken, body, httpOptions);

    }





    sendMessageWithFormData(customer: any, token: string) {
        token = token ? token : this.token;
        const apiUrlWithToken = this.apiUrl + token;

        const httpOptions = {};

        const body = {
            messaging_product: 'whatsapp',
            to: customer?.phone,
            type: 'template',
            template: `{
            "name": ${customer?.templateName},
            "language": { "code": "en_US" },
            "components": [
            {
            }]
        }`
        }

        let tempData = JSON.parse(body.template);
        for (let i = 0; i < customer?.parameters?.length; i++) {
            tempData.components[0].parameters[i].text = customer?.parameters[i]?.text;
            tempData.components[0].parameters[i].type = customer?.parameters[i]?.type;
        }
        body.template = JSON.stringify(tempData);

        const formData = new FormData();
        formData.append('_reqName', 'object:phone-number-id/messages');
        formData.append('_reqSrc', 'WhatsAppBusinessSendMessageAPI');
        formData.append('locale', 'en_US');
        formData.append('messaging_product', 'whatsapp');
        formData.append('method', 'post');
        formData.append('pretty', '0');
        formData.append('suppress_http_code', '1');
        formData.append('template', body?.template);
        formData.append('to', customer?.phone);
        formData.append('type', 'template');
        formData.append('xref', 'f84fbb6170fbefbaf');

        return this.http.post(apiUrlWithToken, formData, httpOptions);
    }

    getIntegrations(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/integrations`);
    }
    getWhatsappList(bussinessId: any, token: any): Observable<any> {
        return this.http.get<any>(`https://graph.facebook.com/v22.0/${bussinessId}/message_templates?access_token=${token}`);
    }
    getMetaWhatsappList(whatsappTemplateId: any, token: any): Observable<any> {
        return this.http.get<any>(`https://graph.facebook.com/v22.0/${whatsappTemplateId}?access_token=${token}`);
    }

    createIntegration(data: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/integrations`, data);
    }

    updateIntegration(id: string, data: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}/integrations/${id}`, data);
    }

    deleteIntegration(id: string): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/integrations/${id}`);
    }
}